/**
 * Enumeration of the possible priority states for a task or goal
 */ export var PriorityName = /*#__PURE__*/ function(PriorityName) {
    /** Urgent state (0-1) */ PriorityName["Urgent"] = "Urgent";
    /** Important state (2-4) */ PriorityName["Important"] = "Important";
    /** Default medium state (5-7) */ PriorityName["Medium"] = "Medium";
    /** Low state (8-10) */ PriorityName["Low"] = "Low";
    return PriorityName;
}({});
/**
 * Access contexts for tasks
 */ export var TaskAccessContext = /*#__PURE__*/ function(TaskAccessContext) {
    /* Plan based tasks access */ TaskAccessContext[TaskAccessContext["Plan"] = 0] = "Plan";
    /** Assignee based tasks access */ TaskAccessContext[TaskAccessContext["AssignedToUser"] = 1] = "AssignedToUser";
    /** My day based tasks access */ TaskAccessContext[TaskAccessContext["MyDay"] = 2] = "MyDay";
    return TaskAccessContext;
}({});
/** Update Plan state */ export var PlanMoveOperationStatus = /*#__PURE__*/ function(PlanMoveOperationStatus) {
    /** Move Plan is in progress. */ PlanMoveOperationStatus["InProgress"] = "InProgress";
    /** Move Plan is completed. */ PlanMoveOperationStatus["Completed"] = "Completed";
    /** Move Plan has completed with errors. */ PlanMoveOperationStatus["CompletedWithErrors"] = "CompletedWithErrors";
    return PlanMoveOperationStatus;
}({});
/**
 * All the possible values for a sensitivity label to enforce group privacy
 */ export var SensitivityLabelGroupPrivacy = /*#__PURE__*/ function(SensitivityLabelGroupPrivacy) {
    SensitivityLabelGroupPrivacy["Public"] = "public";
    SensitivityLabelGroupPrivacy["Private"] = "private";
    SensitivityLabelGroupPrivacy["Unspecified"] = "unspecified";
    return SensitivityLabelGroupPrivacy;
}({});
/**
 * Enum representing the available tabs in the task editor
 */ export var TaskEditorTab = /*#__PURE__*/ function(TaskEditorTab) {
    TaskEditorTab["TaskDetails"] = "taskDetails";
    TaskEditorTab["Planning"] = "planning";
    TaskEditorTab["Attachments"] = "attachments";
    TaskEditorTab["Checklist"] = "checklist";
    TaskEditorTab["Comments"] = "comments";
    TaskEditorTab["CustomFields"] = "customFields";
    TaskEditorTab["Agent"] = "agent";
    return TaskEditorTab;
}({});
